export default () => ({
  root: {
    width: '100%',
  },
  flex: {
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  flexGrow: {
    flexGrow: 1,
  },
  link: {
    color: 'white',
    textDecoration: 'none',
  },
  icon: {
    width: 24,
    height: 24,
    marginRight: 5,
  },
  button: {
    borderRadius: 0,
    margin: 0,
  },
});



// WEBPACK FOOTER //
// ./src/screens/partial/Header.styles.js